import { useState } from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { useController, useFormContext } from "react-hook-form";
import useSWR from "swr";
import { PaginationMeta } from "types";

type Model = { [x: string]: any };

interface Props
    extends Partial<React.ComponentProps<typeof AsyncTypeahead>> {
    name: string;
    id: string;
    url: string;
    multiple?: false;
    labelKey?: string;
    fieldKey?: string;
    dataModifier?: (data: Model[]) => Model[];
    selectionModifier?: (selection: Model) => any;
}

export const FormTypeahead = ({
                                  name,
                                  url,
                                  fieldKey = "full_text",
                                  dataModifier = (data) => data,
                                  selectionModifier = (selection) => selection,
                                  ...props
                              }: Props) => {
    const { control } = useFormContext();
    const {
        field: { onBlur, onChange, value, ref }
    } = useController({ name, control });
    const [query, setQuery] = useState<string>();
    const [showMenu, setShowMenu] = useState(false);
    const { data, error, isLoading } = useSWR<PaginationMeta<Model>>([
        url,
        { filter: JSON.stringify({ [fieldKey]: query }) }
    ]);

    return (
        <AsyncTypeahead
            clearButton
            emptyLabel="Keine Übereinstimmungen gefunden"
            newSelectionPrefix="Eingabe übernehmen"
            allowNew={true}
            labelKey={name as any}
            multiple={false}
            ref={ref}
            open={showMenu}
            onSearch={(query) => setQuery(query)}
            options={dataModifier(data?.data || [])}
            maxResults={data?.per_page}
            isLoading={isLoading}
            {...props}
            onInputChange={() => setShowMenu(true)}
            onChange={(selection) => {
                onChange(selectionModifier(selection));
                setShowMenu(false);
            }}
            selected={value || []}
            onFocus={() => setShowMenu(true)}
            onBlur={() => {
                setShowMenu(false);
                onBlur();
            }}
        />
    );
};
